// extracted by mini-css-extract-plugin
export default {"card":"HowItWorksFooter_card__ecprd","title":"HowItWorksFooter_title__9cLYv","body":"HowItWorksFooter_body__xOhV5"};